import { Component, ElementRef, EventEmitter, Output, OnInit } from '@angular/core';
import $ from 'jquery';

const HIDE_TIMEOUT = 10000;

@Component({
  selector: 'tip',
  styleUrls: ['./tip.component.scss'],
  templateUrl: './tip.component.html',
})
export class TipComponent implements OnInit {
  @Output() public onClosed;
  private $el;
  private $message;
  private timer;

  constructor(el: ElementRef) {
    this.$el = $(el.nativeElement);
    this.onClosed = new EventEmitter();
  }

  public ngOnInit() {
    this.$message = this.$el.find('.ui.message');
  }

  public show({ autoHide = true } = {}) {
    const $msg = this.$message;
    if (this.timer) {
      this._clear();
      $msg.transition('show');
    } else if ($msg.hasClass('hidden')) {
      $msg.transition('fly down');
    }
    if (autoHide) {
      this.timer = setTimeout(this.hide.bind(this), HIDE_TIMEOUT);
    }
  }

  public hide() {
    this._clearTimer();
    this.$message.transition('fly down');
  }

  public onClose() {
    this.hide();
    this.onClosed.emit();
  }

  private _clear() {
    this._clearTimer();
    this.$message.transition('hide');
  }

  private _clearTimer() {
    clearTimeout(this.timer);
    this.timer = null;
  }
}
